export const appleStoreUrl = 'https://cdn.getyourguide.com/tf/assets/static/badges/app-store-badge-en-us.svg';
